import Moon01Icon from '@untitled-ui/icons-react/build/esm/Moon01';
import SunIcon from '@untitled-ui/icons-react/build/esm/Sun';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import SvgIcon from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';
import { alpha, useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useSettings } from 'src/hooks/use-settings';

const MODES = [
  { value: 'light', icon: SunIcon },
  { value: 'dark', icon: Moon01Icon }
];

export const ThemeSwitch = () => {
  const theme = useTheme();
  const { paletteMode, handleUpdate } = useSettings();
  const { i18n } = useTranslation();
  const t = (en, ar) => (i18n.language === 'ar' ? ar : en);
  const activeIndex = paletteMode === 'dark' ? 1 : 0;

  return (
    <Box
      aria-label={t('Theme', 'المظهر')}
      role="group"
      sx={{
        alignItems: 'center',
        bgcolor: (theme) => theme.palette.mode === 'dark'
          ? alpha(theme.palette.common.white, 0.06)
          : alpha(theme.palette.common.black, 0.04),
        border: (theme) => `1px solid ${theme.palette.divider}`,
        borderRadius: 999,
        display: 'inline-flex',
        p: '3px',
        position: 'relative'
      }}
    >
      <Box
        aria-hidden
        sx={{
          bgcolor: 'background.paper',
          borderRadius: 999,
          boxShadow: theme.palette.mode === 'dark'
            ? '0 2px 10px rgba(0,0,0,0.4)'
            : '0 2px 10px rgba(15,23,42,0.1)',
          height: 30,
          left: `calc(${activeIndex * 50}% + 3px)`,
          position: 'absolute',
          top: 3,
          transition: 'left 0.28s cubic-bezier(0.4, 0, 0.2, 1)',
          width: 'calc(50% - 3px)'
        }}
      />
      {MODES.map((mode) => {
        const isActive = paletteMode === mode.value;
        const label = mode.value === 'light'
          ? t('Light mode', 'الوضع الفاتح')
          : t('Dark mode', 'الوضع الداكن');

        return (
          <Tooltip key={mode.value} title={label}>
            <IconButton
              aria-label={label}
              aria-pressed={isActive}
              onClick={() => handleUpdate({ paletteMode: mode.value })}
              size="small"
              sx={{
                borderRadius: 999,
                color: isActive ? 'primary.main' : 'text.secondary',
                height: 30,
                minWidth: 34,
                p: 0,
                transition: 'color 0.2s ease',
                width: 34,
                zIndex: 1,
                '&:hover': {
                  bgcolor: 'transparent',
                  color: isActive ? 'primary.main' : 'text.primary'
                }
              }}
            >
              <SvgIcon sx={{ fontSize: 17 }}>
                <mode.icon />
              </SvgIcon>
            </IconButton>
          </Tooltip>
        );
      })}
    </Box>
  );
};
